import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import {
  activityTimeTitle,
  formatConfidence,
  getActivityChanges,
  isLegacyXproLog,
  isRequestStatusLabel,
} from "../activityLogDisplay";
import { getMessageDate } from "../timelineUtils";

const StatusChip = ({ label }) => {
  if (!label) return null;
  if (!isRequestStatusLabel(label)) {
    return (
      <Typography component="span" variant="caption" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
    );
  }
  return <Chip size="small" label={label} sx={{ height: 20, fontSize: "0.7rem" }} />;
};

const ActivityLogDetail = ({ message }) => {
  const changes = getActivityChanges(message);
  const detail = message?.logMeta?.detail && typeof message.logMeta.detail === "object" ? message.logMeta.detail : null;
  const actions = Array.isArray(detail?.actions)
    ? detail.actions
    : Array.isArray(message?.logMeta?.actionsSummary)
      ? message.logMeta.actionsSummary
      : [];
  const confidence = formatConfidence(detail?.confidence);
  const reasoning = detail?.reasoning ? String(detail.reasoning) : "";
  const origin = detail?.origin || detail?.note || "";
  const when = activityTimeTitle(getMessageDate(message));
  const legacy = isLegacyXproLog(message);
  const entity = message?.logMeta?.entity;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4, textAlign: "left" }}>
      {changes.map((change, index) => (
        <Typography key={`${change.field || "change"}-${index}`} variant="caption" component="div">
          {change.label ? `${change.label}: ` : null}
          <StatusChip label={change.fromLabel} />
          {change.fromLabel && change.toLabel ? " → " : null}
          <StatusChip label={change.toLabel} />
        </Typography>
      ))}
      {actions.length > 1 ? (
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          {actions.map((line) => (
            <Typography key={line} component="li" variant="caption">
              {line}
            </Typography>
          ))}
        </Box>
      ) : null}
      {origin ? (
        <Typography variant="caption" component="div">
          {origin}
        </Typography>
      ) : null}
      {confidence ? (
        <Typography variant="caption" component="div">
          Confiança: {confidence}
        </Typography>
      ) : null}
      {reasoning ? (
        <Typography variant="caption" component="div">
          Motivo: {reasoning}
        </Typography>
      ) : null}
      {detail?.customerMessage ? (
        <Typography variant="caption" component="div">
          Mensagem do cliente: “{String(detail.customerMessage)}”
        </Typography>
      ) : null}
      {entity?.href ? (
        <Typography
          component="a"
          href={entity.href}
          variant="caption"
          sx={{ color: "primary.main" }}
        >
          {entity.label || "Abrir"}
        </Typography>
      ) : null}
      {when ? (
        <Typography variant="caption" component="div" sx={{ color: "text.disabled" }}>
          {when}
        </Typography>
      ) : null}
      {legacy ? (
        <Chip
          size="small"
          label="Xpro clássico"
          title="Este log foi salvo pelo Xpro clássico e pode não ter todos os detalhes."
          sx={{ alignSelf: "center", height: 20, fontSize: "0.68rem" }}
        />
      ) : null}
    </Box>
  );
};

export default ActivityLogDetail;
